export default __webpack_public_path__ + "static/media/new_landing_blog.7b12b64e.png";